/* import __COLOCATED_TEMPLATE__ from './detail-learning-materials.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { guidFor } from '@ember/object/internals';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { all } from 'rsvp';
import scrollIntoView from 'scroll-into-view';
import { TrackedAsyncData } from 'ember-async-data';
import { mapBy } from 'ilios-common/utils/array-helpers';
import sortableByPosition from 'ilios-common/utils/sortable-by-position';
let DetailCohortsComponent = (_class = class DetailCohortsComponent extends Component {
  get lmData() {
    return new TrackedAsyncData(this.args.subject.learningMaterials);
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "isSorting", _descriptor4, this);
    _initializerDefineProperty(this, "managingMaterial", _descriptor5, this);
    _initializerDefineProperty(this, "totalMaterialsToSave", _descriptor6, this);
    _initializerDefineProperty(this, "currentMaterialsSaved", _descriptor7, this);
    _initializerDefineProperty(this, "displayAddNewForm", _descriptor8, this);
    _initializerDefineProperty(this, "type", _descriptor9, this);
    _initializerDefineProperty(this, "learningMaterialStatuses", _descriptor10, this);
    _initializerDefineProperty(this, "learningMaterialUserRoles", _descriptor11, this);
    _defineProperty(this, "saveNewLearningMaterial", _buildTask(() => ({
      context: this,
      generator: function* (lm) {
        const savedLm = yield lm.save();
        let lmSubject;
        let position = 0;
        if (this.materials && this.materials.length) {
          const positions = mapBy(this.materials, 'position');
          position = Math.max(...positions) + 1;
        }
        if (this.args.isCourse) {
          lmSubject = this.store.createRecord('course-learning-material', {
            course: this.args.subject,
            position
          });
        } else {
          lmSubject = this.store.createRecord('session-learning-material', {
            session: this.args.subject,
            position
          });
        }
        lmSubject.set('learningMaterial', savedLm);
        yield lmSubject.save();
        this.displayAddNewForm = false;
        this.type = null;
        scrollIntoView(this.title, {
          align: {
            top: 0
          }
        });
      }
    }), null, "saveNewLearningMaterial", "drop"));
    _defineProperty(this, "saveSortOrder", _buildTask(() => ({
      context: this,
      generator: function* (learningMaterials) {
        const materialsToSave = [];
        for (let i = 0, n = learningMaterials.length; i < n; i++) {
          const lm = learningMaterials[i];
          const position = i + 1;
          if (lm.position != position) {
            lm.set('position', position);
            materialsToSave.push(lm);
          }
        }
        yield this.saveSomeMaterials(materialsToSave);
        this.isSorting = false;
        scrollIntoView(this.title, {
          align: {
            top: 0
          }
        });
      }
    }), null, "saveSortOrder", "drop"));
    _defineProperty(this, "addLearningMaterial", _buildTask(() => ({
      context: this,
      generator: function* (parentLearningMaterial) {
        let newLearningMaterial;
        if (this.args.isCourse) {
          newLearningMaterial = this.store.createRecord('course-learning-material', {
            course: this.args.subject,
            learningMaterial: parentLearningMaterial,
            position: 0
          });
        } else {
          newLearningMaterial = this.store.createRecord('session-learning-material', {
            session: this.args.subject,
            learningMaterial: parentLearningMaterial,
            position: 0
          });
        }
        let position = 0;
        if (this.materials && this.materials.length > 1) {
          const positions = mapBy(this.materials, 'position');
          position = Math.max(...positions) + 1;
        }
        newLearningMaterial.set('position', position);
        yield newLearningMaterial.save();
      }
    }), null, "addLearningMaterial", "drop"));
    _defineProperty(this, "remove", _buildTask(() => ({
      context: this,
      generator: function* (lm) {
        lm.deleteRecord();
        return yield lm.save();
      }
    }), null, "remove", "drop"));
    this.learningMaterialStatuses = this.store.peekAll('learning-material-status');
    this.learningMaterialUserRoles = this.store.peekAll('learning-material-user-role');
  }
  get titleId() {
    return `detail-learning-materials-header-${guidFor(this)}`;
  }
  get title() {
    return document.getElementById(this.titleId);
  }
  get materials() {
    if (!this.lmData.isResolved) {
      return [];
    }
    return this.lmData.value.slice().sort(sortableByPosition);
  }
  get parentMaterialIds() {
    return this.materials.map(lm => {
      return lm.belongsTo('learningMaterial').id();
    });
  }
  get isManaging() {
    return !!this.managingMaterial;
  }
  get isSession() {
    return !this.args.isCourse;
  }
  get displaySearchBox() {
    return !this.isManaging && !this.displayAddNewForm && !this.isSorting && this.args.editable;
  }
  get hasMoreThanOneLearningMaterial() {
    return this.materials && this.materials.length > 1;
  }
  setManagedMaterial(lm) {
    this.managingMaterial = lm;
  }
  addNewLearningMaterial(type) {
    this.type = type;
    this.displayAddNewForm = true;
  }
  closeLearningmaterialManager() {
    this.setManagedMaterial(null);
    scrollIntoView(this.title, {
      align: {
        top: 0
      }
    });
  }
  closeNewLearningmaterial() {
    this.displayAddNewForm = false;
    scrollIntoView(this.title, {
      align: {
        top: 0
      }
    });
  }
  async saveSomeMaterials(arr) {
    const chunk = arr.splice(0, 5);
    const savedMaterials = await all(chunk.map(o => o.save()));
    let moreMaterials = [];
    if (arr.length) {
      moreMaterials = await this.saveSomeMaterials(arr);
    }
    return [].concat(savedMaterials, moreMaterials);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isSorting", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "managingMaterial", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "totalMaterialsToSave", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentMaterialsSaved", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "displayAddNewForm", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "type", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "learningMaterialStatuses", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "learningMaterialUserRoles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "lmData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "lmData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "materials", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "materials"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setManagedMaterial", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setManagedMaterial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNewLearningMaterial", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewLearningMaterial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeLearningmaterialManager", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeLearningmaterialManager"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeNewLearningmaterial", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeNewLearningmaterial"), _class.prototype), _class);
export { DetailCohortsComponent as default };